<div class="modal-header">
    <h4 class="modal-title fw-bold" id="importLotHeader" jhiTranslate="inventoryManagerApp.lot.import.title">Import lots</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="close()">
    </button>
</div>
<div class="modal-body">
    <div class="col-8 mb-3 d-flex align-items-center">
        <span jhiTranslate="template.download.description"></span>&nbsp;<a href (click)="export($event)" jhiTranslate="template.download.here" data-test="downloadTemplateLink"></a>.
    </div>
    <div class="row mb-3 add_top_padding" style="margin-bottom: 35px;">
        <div class="col-2"></div>
        <div class="col-md-8">
            <label class="form-label"  for="importFile"><i class="fa fa-search"></i> {{"inventoryManagerApp.lot.import.deposits.field.file" | translate}}</label>

			<jhi-file-select id="fileUpload"
							 [acceptedFileTypes]="selectedFileType"
							 (fileSelected)="onFileChange($event)"
							 (fileCleared)="clearSelectedFile()">
			</jhi-file-select>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="close()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button (click)="import()" class="btn btn-primary" [disabled]="fileName === '' ? 'disabled' : null" data-test="importLotsButton">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.import">Import</span>
    </button>
</div>

